<template>
	<CList :pConfigList="ConfigList" :segurity="segurity">
		<template slot="bodyForm">
			<CLoader :pConfigLoad="ConfigLoad">
				<template slot="BodyFormLoad">
					<div class="container-fluid">
						<form id="FormNotaPago" role="form" method="post" autocomplete="off" onSubmit="return false">

							<div class="row">
								<div class="col-12 col-sm-12 col-md-3 col-lg-3">
									<label for="MesInventario">Meses</label>
									<select v-model="objInventario.MesInventario" class="form-control form-select" name="MesInventario" id="MesInventario">
										<option value="0">Seleccione una opción</option>
										<option v-for="(item,index) in CalendarioMeses" :key="index" :value="item.clave">{{item.label}}</option>
									</select>
								</div>

								<div class="col-12 col-sm-12 col-md-3 col-lg-3">
									<label for="AnioInventario">Año</label>
									<select v-model="objInventario.AnioInventario" class="form-control form-select" name="AnioInventario" id="AnioInventario">
										<option v-for="(item,index) in Anios" :key="index" :value="item">{{item}}</option>
									</select>
								</div>

								<div class="col-12 col-sm-12 col-md-3 col-lg-3 text-end">
									<br>
									<button type="button" @click="CargarReporte()" class="btn btn-primary" id="button-addon2">
										<i class="fa fa-plus-circle"></i> Cargar  Reporte
									</button>
								</div>
							</div>
							
							<hr class="horizontal dark">

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<nav>
										<div class="nav nav-tabs" id="nav-tab2" role="tablist">
											<button type="button" class="nav-link active" id="nav-elementos-tab" data-bs-toggle="tab" data-bs-target="#nav-elementos" role="tab" aria-controls="nav-elementos" aria-selected="false">
												Galeria
											</button>

											<button type="button" class="nav-link" id="nav-herramientas-tab" data-bs-toggle="tab" data-bs-target="#nav-herramientas" role="tab" aria-controls="nav-herramientas" aria-selected="false">
												Herramientas
											</button>

											<button type="button" class="nav-link" id="nav-insumos-tab" data-bs-toggle="tab" data-bs-target="#nav-insumos" role="tab" aria-controls="nav-insumos" aria-selected="false">
												Insumos
											</button>

											<button type="button" class="nav-link" id="nav-materiales-tab" data-bs-toggle="tab" data-bs-target="#nav-materiales" role="tab" aria-controls="nav-materiales" aria-selected="false">
												Materiales
											</button>
										</div>
									</nav>

									<div class="tab-content" id="nav-tabContent">
										<div class="tab-pane fade show active pt-3" id="nav-elementos" role="tabpanel" aria-labelledby="nav-elementos-tab">
											<div class="table-responsive">
												<table class="table align-items-center mb-0">
													<thead>
														<tr>
															<th>Nombre</th>
															<th>Inventario Inicial</th>
															<th>TotalS alidas</th>
															<th>Total Retornos</th>
															<th>Total Mermas</th>
															<th>Inventario Final</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item,index) in Galeria" :key="index">
															<td>{{$limitCharacters(item.Descripcion)}}</td>
															<td>{{item.InventarioInicial}}</td>
															<td>{{item.TotalSalidas}}</td>
															<td>{{item.TotalRetornos}}</td>
															<td>{{item.TotalMermas}}</td>
															<td>{{item.InventarioFinal}}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>

										<div class="tab-pane fade show" id="nav-herramientas" role="tabpanel" aria-labelledby="nav-herramientas-tab">
											<div class="table-responsive">
												<table class="table align-items-center mb-0">
													<thead>
														<tr>
															<th>Nombre</th>
															<th>Inventario Inicial</th>
															<th>TotalS alidas</th>
															<th>Total Retornos</th>
															<th>Total Mermas</th>
															<th>Inventario Final</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item,index) in Herramientas" :key="index">
															<td>{{item.Nombre}}</td>
															<td>{{item.InventarioInicial}}</td>
															<td>{{item.TotalSalidas}}</td>
															<td>{{item.TotalRetornos}}</td>
															<td>{{item.TotalMermas}}</td>
															<td>{{item.InventarioFinal}}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>

										<div class="tab-pane fade show" id="nav-insumos" role="tabpanel" aria-labelledby="nav-insumos-tab">
											<div class="table-responsive">
												<table class="table align-items-center mb-0">
													<thead>
														<tr>
															<th>Nombre</th>
															<th>Inventario Inicial</th>
															<th>TotalS alidas</th>
															<th>Total Retornos</th>
															<th>Total Mermas</th>
															<th>Inventario Final</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item,index) in Insumos" :key="index">
															<td>{{item.Nombre}}</td>
															<td>{{item.InventarioInicial}}</td>
															<td>{{item.TotalSalidas}}</td>
															<td>{{item.TotalRetornos}}</td>
															<td>{{item.TotalMermas}}</td>
															<td>{{item.InventarioFinal}}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>

										<div class="tab-pane fade show" id="nav-materiales" role="tabpanel" aria-labelledby="nav-materiales-tab">
											<div class="table-responsive">
												<table class="table align-items-center mb-0">
													<thead>
														<tr>
															<th>Nombre</th>
															<th>Inventario Inicial</th>
															<th>TotalS alidas</th>
															<th>Total Retornos</th>
															<th>Total Mermas</th>
															<th>Inventario Final</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="(item,index) in Materiales" :key="index">
															<td>{{item.Nombre}}</td>
															<td>{{item.InventarioInicial}}</td>
															<td>{{item.TotalSalidas}}</td>
															<td>{{item.TotalRetornos}}</td>
															<td>{{item.TotalMermas}}</td>
															<td>{{item.InventarioFinal}}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
								
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label class="form-label" for="Observaciones">Observaciones</label>
									<textarea v-model="objInventario.Observaciones" class="form-control" id="Observaciones" placeholder="Ingresar Observaciones" rows="3"></textarea>
									<CValidation v-if="this.errorvalidacion.Observaciones" :Mensaje="'*'+errorvalidacion.Observaciones[0]"/>
								</div>
							</div>
							
													
							<br>
							<CBtnSave :poBtnSave="oBtnSave" />
						</form>

					</div>
				</template>
			</CLoader>
		</template>
	</CList>
	
</template>
<script>
import moment from 'moment';
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta = 'seccionInventario';


export default {
    name: 'FormInventario',
    props: ['Id'],
    components:{
    },
    data() {
        return {
			ConfigList:{
                Title: 'Inventario Reporte Mensual',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
				ShowTitleFirst: false,
                TypeBody: 'Form',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'inventario',
                EmitSeccion: EmitEjecuta,
				ShowBtnSave: true,
            },
			ConfigLoadTable:{
                ShowLoader: false,
                ClassLoad: false,
            },
			objInventario: {
				IdInventario: 0,
				IdUsuarioGenero: 0,
				IdUsuarioAutorizo: 0,
				FechaRegistro: '',
				FechaAutorizacion: '',
				Estatus: 'Pendiente',
				MesInventario: 0,
				AnioInventario: moment(new Date()).format('YYYY'),
				Observaciones: '',
				IdEmpresa: 0,
				IdSucursal: 0,
			},
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
			CalendarioMeses: Calendar.CalendarioMeses,
			Galeria: [],
			Herramientas: [],
			Insumos: [],
			Materiales: [],
			Anios: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
			formData.set('IdInventario', this.objInventario.IdInventario);
			formData.set('IdUsuarioGenero', this.objInventario.IdUsuarioGenero);
			formData.set('IdUsuarioAutorizo', this.objInventario.IdUsuarioAutorizo);
			formData.set('FechaRegistro', this.objInventario.FechaRegistro);
			formData.set('FechaAutorizacion', this.objInventario.FechaAutorizacion);
			formData.set('Estatus', this.objInventario.Estatus);
			formData.set('MesInventario', this.objInventario.MesInventario);
			formData.set('AnioInventario', this.objInventario.AnioInventario);
			formData.set('Observaciones', this.objInventario.Observaciones);
			formData.set('IdEmpresa', this.objInventario.IdEmpresa);
			formData.set('IdSucursal', this.objInventario.IdSucursal);

			formData.set('Materiales', JSON.stringify(this.Materiales));
			formData.set('Galeria', JSON.stringify(this.Galeria));
			formData.set('Herramientas', JSON.stringify(this.Herramientas));
			formData.set('Insumos', JSON.stringify(this.Insumos));
			
			
			this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
			
			await this.$http.post('inventarios', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err)
        {
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "solicitudesAlmacen/"+this.objInventario.IdNotaPago
            ).then((res) => {
                this.objInventario = res.data.data;
				let response = res.data.detalle;

				this.ListaConceptosSalida = response;


				// en caso de que necesite fecha
				/*let formatedDate1 = this.objInventario.Fecha.replace(/-/g,'\/');
                this.objInventario.Fecha = new Date(formatedDate1);*/

				if(this.objInventario.Estatus != 'Elaborado'){
					this.oBtnSave.ShowBtnSave = false;
				}
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
			this.objInventario = {
				IdInventario: 0,
				IdUsuarioGenero: 0,
				IdUsuarioAutorizo: 0,
				FechaRegistro: moment(new Date()).format('YYYY-MM-DD'),
				FechaAutorizacion: '',
				Estatus: 'Pendiente',
				MesInventario: 0,
				AnioInventario: moment(new Date()).format('YYYY'),
				Observaciones: '',
				IdEmpresa: 0,
				IdSucursal: 0,
			}
    
            this.errorvalidacion = [];
        },
		Regresar() {
            this.$router.push({name:this.oBtnSave.ReturnRoute});
            // this.$router.push({name:'routeraregresar',params:{obj:this.obj}});
        },
		GetAnio()
		{	
			let AnioInicio = 2026;
			let AnioActual = new Date().getFullYear(); // Detecta dinámicamente el año en curso
			let Anios = [];

			for (let i = AnioInicio; i <= AnioActual; i++) {
				Anios.push(i);
			}

			this.Anios = Anios;
		},
		CargarReporte()
		{
			if(this.objInventario.MesInventario == 0){
				this.$toast.warning('Por Favor Seleccione Un Mes');
				return false;
			}
			this.ConfigLoad.ShowLoader = true;

			this.$http.get('cargarReporteInventario', {
				params: {
					Mes: this.objInventario.MesInventario,
					Anio: this.objInventario.AnioInventario,
				}
			}).then((res) =>
			{
				let Response = res.data.data
				console.log(res.data.data)

				this.Materiales = Response.Materiales;
				this.Galeria = Response.Galeria;
				this.Herramientas = Response.Herramientas;
				this.Insumos = Response.Insumos;


			}).finally(() =>
			{
				this.ConfigLoad.ShowLoader = false;
			});
		},
    },
	created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        this.GetAnio();

        if(this.Id!='') 
        {
            this.objInventario.IdInventario = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
			// this.SetElabora();

		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
